// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"606":"f98060cd","687":"ac38d7e7","786":"ce81ce55"}[chunkId] + ".css";
};